import { render, staticRenderFns } from "./TfootEx.vue?vue&type=template&id=16c47401&scoped=true&"
import script from "./TfootEx.vue?vue&type=script&lang=js&"
export * from "./TfootEx.vue?vue&type=script&lang=js&"
import style0 from "./TfootEx.vue?vue&type=style&index=0&id=16c47401&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16c47401",
  null
  
)

export default component.exports